import { ButtonHTMLAttributes } from "react";
import "./index.scss";

const Button = ({
  children,
  id = "",
  className = "",
  ...remainingProps
}: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button
      id={id}
      className={`component button ${className}`}
      {...remainingProps}
    >
      {children}
    </button>
  );
};

export default Button;
